import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=7406b847&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=7406b847&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406b847",
  null
  
)

export default component.exports